<template>
  <div>
    <v-toolbar flat color="white">
      <v-tabs div="tabs">
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="activeAccounts=true;pendingAccounts=false; inactiveAccounts=false; changeRequestTab = false; customerRequestTab = false">
          Active<v-chip color="light-green" class="white--text">{{activeServiceAccounts.length}}</v-chip>
        </v-tab>
        <v-tab @click="activeAccounts=false;pendingAccounts=true; inactiveAccounts=false; changeRequestTab = false; customerRequestTab = false">
          Pending<v-chip color="blue" class="white--text">{{pendingServiceAccounts.length}}</v-chip>
        </v-tab>
        <v-tab @click="activeAccounts=false;pendingAccounts=false; inactiveAccounts=true; changeRequestTab = false; customerRequestTab = false">
          Inactive<v-chip color="red" class="white--text">{{inactiveServiceAccounts.length}}</v-chip>
        </v-tab>
        <v-tab @click="activeAccounts=false;pendingAccounts=false; inactiveAccounts=false; changeRequestTab = true; customerRequestTab = false">
          Change Requests<v-chip color="orange" class="white--text">{{changeRequests.filter(x=>x.status !== 'Resolved' && x.status !== 'Denied').length}}</v-chip>
        </v-tab>
        <v-tab @click="activeAccounts=false;pendingAccounts=false; inactiveAccounts=false; changeRequestTab = false; customerRequestTab = true">
          Customer Requests<v-chip color="purple" class="white--text">{{customerRequests.filter(x=>!x.isResolved).length}}</v-chip>
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <!-- Active Accounts -->
    <div v-if="activeAccounts">
      <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field v-model="activeSearch" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table
    :search="activeSearch"
    :loading="isLoading"
    :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
    :items="activeServiceAccounts"
    :headers="activeHeaders"
    disable-initial-sort
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-layout align-center justify-center>
            <v-icon @click="changeRequest(props.item)">query_builder</v-icon>
            </v-layout>
            </td>
        <td class="text-xs-center">{{props.item.id}}</td>
        <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
        <td class="text-xs-center">{{formatDate(props.item.fnoActivationDate)}}</td>
        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
         <td class="text-xs-center" v-if="props.item.deviceBridgeId != null">{{props.item.deviceBridge.vlan}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.deviceBridgeId != null">{{props.item.deviceBridge.vlanXlate}}</td>
        <td v-else></td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>

      </template>
    </v-data-table>
    </div>

    <!-- Pending Accounts -->
    <div v-if="pendingAccounts">
      <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field v-model="pendingSearch" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table
    :search="pendingSearch"
    :loading="isLoading"
    :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
    :items="pendingServiceAccounts"
    :headers="pendingHeaders"
    disable-initial-sort
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <!-- <v-layout justify-center align-center>
            <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on">
        <v-icon  color="light-green">done</v-icon>
        </v-btn>
      </template>
      <span>Accept Account</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on">
        <v-icon color="red">clear</v-icon>
        </v-btn>
      </template>
      <span>Reject Account</span>
    </v-tooltip>
          </v-layout> -->
          
        </td>
        <td class="text-xs-center">{{props.item.id}}</td>
        <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
        <td class="text-xs-center">{{formatDate(props.item.fnoActivationDate)}}</td>
        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
         <td class="text-xs-center" v-if="props.item.deviceBridgeId != null">{{props.item.deviceBridge.vlan}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.deviceBridgeId != null">{{props.item.deviceBridge.vlanXlate}}</td>
        <td v-else></td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>

      </template>
    </v-data-table>
    </div>


    <!-- Inactive Accounts -->
    <div v-if="inactiveAccounts">
      <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field v-model="inactiveSearch" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table
    :search="inactiveSearch"
    :loading="isLoading"
    :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
    :items="inactiveServiceAccounts"
    :headers="headers"
    disable-initial-sort
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{props.item.id}}</td>
        <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
        <td class="text-xs-center">{{formatDate(props.item.fnoActivationDate)}}</td>
        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
         <td class="text-xs-center" v-if="props.item.deviceBridgeId != null">{{props.item.deviceBridge.vlan}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.deviceBridgeId != null">{{props.item.deviceBridge.vlanXlate}}</td>
        <td v-else></td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>

      </template>
    </v-data-table>
    </div>
    <!-- Change Requests -->
    <div v-if="changeRequestTab">
      <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field v-model="changeRequestSearch" label="Search"></v-text-field>
    </v-toolbar>
    <v-toolbar flat color="white">
        <v-tabs>
      <v-tab @click="showPendingRequests=true; showResolvedRequests=false">Pending</v-tab>
      <v-tab @click="showPendingRequests=false; showResolvedRequests=true">Resolved</v-tab>
    </v-tabs>
    </v-toolbar>
    <div v-if="showPendingRequests">
       <v-data-table
    :search="changeRequestSearch"
    :loading="isLoading"
    :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
    :items="changeRequests.filter(x=>x.status !== 'Resolved' && x.status !== 'Denied')"
    :headers="changeRequestHeaders"
    disable-initial-sort
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          {{formatDate(props.item.createdAt)}}
        </td>
         <td class="text-xs-center">
           {{props.item.serviceAccountId}}
        </td>
        <td class="text-xs-center" v-if="props.item.status==='Denied'">
          <v-chip class="red white--text">{{props.item.status}}</v-chip>
        </td>
        <td class="text-xs-center" v-if="props.item.status==='Resolved'">
          <v-chip class="primary white--text">{{props.item.status}}</v-chip>
        </td>
        <td class="text-xs-center" v-if="props.item.status==='Pending'">
          <v-chip class="blue white--text">{{props.item.status}}</v-chip>
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.requestType==='Speed Upgrade'||props.item.requestType==='Speed Downgrade'"
        >
          <v-icon v-if="props.item.requestType==='Speed Upgrade'" color="primary">arrow_upward</v-icon>
          <v-icon v-if="props.item.requestType==='Speed Downgrade'" color="red">arrow_downward</v-icon>
          {{props.item.requestType}}
          <br />
          From: {{props.item.fromSpeedProfileName}} Mbps
          <br />
          To: {{props.item.toSpeedProfileName}} Mbps
        </td>
        <td class="text-xs-center" v-else>{{props.item.requestType}}</td>
        <td class="text-xs-center">{{props.item.locationDescription}}</td>
        <td class="text-xs-center">{{formatDate(props.item.requestedChangeDate)}}</td>
      </template>
    </v-data-table>
    </div>
    <div v-if="showResolvedRequests">
       <v-data-table
    :search="changeRequestSearch"
    :loading="isLoading"
    :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
    :items="changeRequests.filter(x=>x.status == 'Resolved' || x.status == 'Denied')"
    :headers="resolvedChangeRequestHeaders"
    disable-initial-sort
    >
      <template v-slot:items="props">
         <td class="text-xs-center">
          {{formatDate(props.item.createdAt)}}
        </td>
         <td class="text-xs-center">
           {{props.item.serviceAccountId}}
        </td>
        <td class="text-xs-center" v-if="props.item.status==='Denied'">
          <v-chip class="red white--text">{{props.item.status}}</v-chip>
        </td>
        <td class="text-xs-center" v-if="props.item.status==='Resolved'">
          <v-chip class="primary white--text">{{props.item.status}}</v-chip>
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.requestType==='Speed Upgrade'||props.item.requestType==='Speed Downgrade'"
        >
          <v-icon v-if="props.item.requestType==='Upgrade'" color="primary">arrow_upward</v-icon>
          <v-icon v-if="props.item.requestType==='Downgrade'" color="red">arrow_downward</v-icon>
          {{props.item.requestType}}
          <br />
          From: {{props.item.fromSpeedProfileName}} Mbps
          <br />
          To: {{props.item.toSpeedProfileName}} Mbps
        </td>
        <td class="text-xs-center" v-else>{{props.item.requestType}}</td>
        <td class="text-xs-center">{{props.item.locationDescription}}</td>
        <td class="text-xs-center">{{formatDate(props.item.requestedChangeDate)}}</td>
        <td class="text-xs-center">{{formatDate(props.item.dateResolved)}}</td>
      </template>
    </v-data-table>
    </div>
   
    </div>

    <div v-if="customerRequestTab">
      <v-data-table
    :search="changeRequestSearch"
    :loading="isLoading"
    :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
    :items="customerRequests.filter(x=>!x.isResolved)"
    :headers="customerRequestHeaders"
    disable-initial-sort
    >
      <template v-slot:items="props">
         <td class="text-xs-center">
          <v-layout justify-center align-center>
            <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on" @click="acceptCustomerRequest(props.item)">
        <v-icon  color="light-green">done</v-icon>
        </v-btn>
      </template>
      <span>Accept Request</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on" @click="rejectCustomerRequest(props.item)">
        <v-icon color="red">clear</v-icon>
        </v-btn>
      </template>
      <span>Reject Request</span>
    </v-tooltip>
          </v-layout>
          
        </td>
         <td class="text-xs-center">
          {{formatDate(props.item.createdAt)}}
        </td>
        <td class="text-xs-center">
          {{formatDate(props.item.requestedDate)}}
        </td>
         <td class="text-xs-center">
          <v-chip color="primary" class="white--text">{{props.item.requestType}}</v-chip>
        </td>
         <td class="text-xs-center" v-if="props.item.requestType =='Upgrade'||props.item.requestType =='Downgrade'">
           {{props.item.fromIspPackage.name}}
        </td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.requestType =='Upgrade'||props.item.requestType =='Downgrade'">
           {{props.item.toIspPackage.name}}
        </td>
        <td v-else></td>
        <td class="text-xs-center">
          {{props.item.contact.name}} {{props.item.contact.surname}}
        </td>
      </template>
    </v-data-table>
    </div>

    <v-dialog v-model="changeRequestDialog" persistent min-width="250px" max-width="500px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Change Request</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="changeRequestDialog=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-select :items="requestTypes" label="Request Type" v-model="changeRequestItem.requestType"></v-select>
          <v-layout wrap justify-center align-center v-if="changeRequestItem.requestType==='Speed Upgrade'||changeRequestItem.requestType==='Speed Downgrade'">
            <v-flex xs12>
              <v-layout align-center justify-center>
                <v-flex xs6><h3 class="grey--text">From:</h3></v-flex>
                <v-flex xs6><h3 class="grey--text">To:</h3></v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout align-center justify-center>
                <v-flex xs6><h3 class="grey--text font-weight-light">{{changeRequestItem.fromSpeed.name}}</h3></v-flex>
                <v-flex xs6>
                  <v-autocomplete v-if="packagesIsp.length>0&&changeRequestItem.requestType==='Speed Downgrade'&&packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps<changeRequestItem.fromSpeed.downloadMbps).length>0" class="mt-1" :items="packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps<changeRequestItem.fromSpeed.downloadMbps)" v-model="changeRequestItem.toSpeed" item-text="packagesFno.speedProfile.name" return-object label="Select a Speed"></v-autocomplete>
                  <span class="grey--text" v-else-if="changeRequestItem.requestType==='Speed Downgrade'">No downgrade speeds available.</span>
                  <v-autocomplete v-if="packagesIsp.length>0&&changeRequestItem.requestType==='Speed Upgrade'&&packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps>changeRequestItem.fromSpeed.downloadMbps).length>0" class="mt-1" :items="packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps>changeRequestItem.fromSpeed.downloadMbps)" v-model="changeRequestItem.toSpeed"  item-text="packagesFno.speedProfile.name" return-object label="Select a Speed"></v-autocomplete>
                  <span v-else-if="changeRequestItem.requestType==='Speed Upgrade'" class="grey--text">No upgrade speeds available.</span>
                </v-flex>
              </v-layout>
            </v-flex>
            
          </v-layout>
          <v-flex xs12 v-if="changeRequestItem.requestType">
            <v-layout justify-center wrap>
              <h3 class="grey--text">Request effective from:</h3>
               <v-date-picker
              landscape
              :min="today"
              v-model="requestedChangeDate"
              class="mt-3"
            ></v-date-picker>
            </v-layout>
             
            </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn @click="logServiceAccountChange()" color="primary" round class="white--text" v-if="changeRequestItem.requestType==='Termination'">Log Request</v-btn>
            <v-btn @click="logServiceAccountChange()" color="primary" round class="white--text" v-else-if="changeRequestItem.requestType==('Speed Upgrade'||'Speed Downgrade')&&changeRequestItem.toSpeed">Log Request</v-btn>
            <v-btn disabled v-else round>Log Request</v-btn>

          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data(){
    return {
      requestTypes: ["Speed Upgrade", "Speed Downgrade", "Termination"],
      isLoading: true,
      changeRequestDialog: false,
      changeRequestTab: false,
      requestedChangeDate: new Date().toISOString().substr(0, 10),
      today: new Date().toISOString().substr(0, 10),
      activeSearch: "",
      pendingSearch: "",
      inactiveSearch: "",
      changeRequestSearch: "",
      activeAccounts: true,
      pendingAccounts: false,
      inactiveAccounts: false,
      showResolvedRequests: false,
      showPendingRequests: true,
      customerRequestTab: false,
      customerRequests: [],
      changeRequestItem:{
        requestType: '',
        fromSpeed: null,
        toSpeed: null,
        terminate: false
      },
      defaultChangeRequestItem:{
        requestType: '',
        fromSpeed: null,
        toSpeed: null,
        terminate: false
      },
      allServiceAccounts: [],
      activeServiceAccounts:[],
      changeRequests: [],
      pendingServiceAccounts: [],
      inactiveServiceAccounts: [],
      allLocations: [],
      allNetworks: [],
      allCustomers: [],
      allSpeedProfiles: [],
      allIspPackages: [],
      packagesIsp: [],
      activeHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Identifier",
          align: "center",
          value: "id"
        },
         {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Date Activated",
          align: "center",
          value: "fnoActivationDate"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "deviceBridge.vlan"
        },
         {
          text: "Outer VLAN",
          align: "center",
          value: "deviceBridge.vlanXlate"
        },
        {
          text: "Download Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "Upload Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
        }
      ],
      pendingHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Identifier",
          align: "center",
          value: "id"
        },
         {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Date Activated",
          align: "center",
          value: "fnoActivationDate"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
       {
          text: "Inner VLAN",
          align: "center",
          value: "deviceBridge.vlan"
        },
         {
          text: "Outer VLAN",
          align: "center",
          value: "deviceBridge.vlanXlate"
        },
        {
          text: "Download Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "Upload Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
        }
      ],
      headers: [
        {
          text: "Identifier",
          align: "center",
          value: "id"
        },
         {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Date Activated",
          align: "center",
          value: "fnoActivationDate"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "deviceBridge.vlan"
        },
         {
          text: "Outer VLAN",
          align: "center",
          value: "deviceBridge.vlanXlate"
        },
        {
          text: "Download Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "Upload Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
        }
      ],
      changeRequestHeaders: [
          {
          text: "Created",
          align: "center",
          value: "vlan.serviceVlan"
        },
        
        {
          text: "Service Account Identitifer",
          align: "center",
          value: "serviceAccountId"
        },
        {
          text: "Status",
          align: "center",
          value: "status"
        },
        {
          text: "Request Type",
          align: "center",
          value: "requestType"
        },
        {
          text: "Location",
          align: "center",
          value: "locationDescription"
        },
        {
          text: "Requested Change Date",
          align: "center",
          value: "requestedChangeDate"
        }
      ],
      resolvedChangeRequestHeaders: [
         {
          text: "Created",
          align: "center",
          value: "createdAt"
        },
         {
          text: "Service Account Identifier",
          align: "center",
          value: "serviceAccountId"
        },
          {
          text: "Status",
          align: "center",
          value: "status"
        },
        {
          text: "Request Type",
          align: "center",
          value: "Request Type"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Requested Change Date",
          align: "center",
          value: "requestedChangeDate"
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "dateResolved"
        }
      ],
      customerRequestHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
         {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
         {
          text: "Requested Change Date",
          align: "center",
          value: "requestedDate"
        },
          {
          text: "Request Type",
          align: "center",
          value: "requestType"
        },
        {
          text: "From Package",
          align: "center",
          value: "fromIspPackage.name"
        },
        {
          text: "To Package",
          align: "center",
          value: "toIspPackage.name"
        },
        {
          text: "Submitted By",
          align: "center",
          value: "contact.name"
        }
      ]
    }
  },
  created(){
    this.initialize()
  },
  methods: {
    initialize(){
      this.getAllServiceAccounts()
      this.fetchCustomers()
      this.fetchSpeedProfiles()
      this.getAllIspPackages()
      this.getChangeRequests()
      this.getCustomerRequests()
    },
    getCustomerRequests(){
      Api()
      .get('/customer/endCustomerRequests')
      .then(response=>{
        this.customerRequests = response.data
      })
    },
    getChangeRequests(){
      Api()
      .get('/customer/serviceAccountsAuditLog')
      .then(response=>{
        this.changeRequests = response.data
      })
    },
    getAllServiceAccounts(){
      Api()
      .get("/customer/serviceAccounts")
      .then(response=>{
        this.isLoading=false
        this.allServiceAccounts=response.data
        this.activeServiceAccounts=response.data.filter(x=>x.fnoActivationDate !== null && new Date(x.fnoActivationDate)<=new Date()&&x.isActive)
        this.pendingServiceAccounts=response.data.filter(x=>x.fnoActivationDate == null || (new Date(x.fnoActivationDate)>new Date())&&x.isActive)
        this.inactiveServiceAccounts=response.data.filter(x=>!x.isActive)
      })
    },

    async fetchCustomers() {
      await Api()
        .get("/organisation/subOrganisations/ISP")
        .then(response => {
          this.allCustomers = response.data;
        });
    },

  acceptRequestChange(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      if (item.requestType !== "Termination") {
        let locationId = null;
        let deviceId = null;
        if (item.requestType === "Migration") {
          locationId = item.migrationLocationId;
          deviceId = null;
        } else {
          locationId = item.locationId;
          deviceId = item.deviceId;
        }
        Api().put("/serviceAccounts/" + item.serviceAccountId, {
          ispDeactivationDate: item.requestedChangeDate,
          fnoDeactivationDate: item.requestedChangeDate
        });
        if (item.authenticationType === "PPPoE") {
          item.IPoEActive = null;
        } else {
          item.IPoEActive = true;
        }
        let packagesIspId = null;
        if (item.toSpeedProfileId === null) {
          packagesIspId = item.packagesIspId;
        } else {
          packagesIspId = item.toSpeedProfileId;
        }
          Api().post("/serviceAccounts", {
            serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
            authenticationType: item.authenticationType,
            pppoeUsername: item.pppoeUsername || null,
            pppoePassword: item.pppoePassword || null,
            IPoEMacAddress: item.IPoEMacAddress,
            initialActivation: item.initialActivation,
            fnoActivationDate: item.requestedChangeDate || null,
            fnoDeactivationDate: null,
            ispActivationDate: item.requestedChangeDate || null,
            ispDeactivationDate: null,
            staticIpv4: item.staticIpv4 || null,
            staticIpv6: item.staticIpv6 || null,
            isChange: true,
            locationId: locationId,
            customerOrganisationId: item.customerOrganisationId,
            deviceId: deviceId,
            packagesIspId: packagesIspId,
            vlanId: item.vlanId,
            IPoEActive: item.IPoEActive,
            isDeleted: false,
            isActive: true
          });
      } else {
        Api().put("/serviceaccounts/" + item.serviceAccountId, {
          fnoDeactivationDate: item.requestedChangeDate,
          ispDeactivationDate: item.requestedChangeDate
        });
      }
      Api()
        .put("/serviceAccountsAuditLog/" + item.serviceAccountAuditLogId, {
          fnoContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
          isActive: false,
           requestedChangeDate: item.requestedChangeDate,
            deviceId: item.deviceId,
            serviceAccountId: item.serviceAccountId,
          status: "Resolved",
          dateResolved: new Date()
        })
        .then(this.initialize());
      }
    },
    acceptCustomerRequest(item){
      confirm("Accepting this sends the request through the the FNO for final approval, would you still like to proceed?")&&
       Api()
        .post("/customer/serviceAccountsAuditLog", {
          status: "Pending",
          serviceAccountId: item.serviceAccountId,
          serviceAccountIdentifier: item.serviceAccount.serviceAccountIdentifier,
          locationId: item.serviceAccount.locationId,
          ispName: this.$store.state.currentOrg.org.name,
          // vlanId: this.changeRequestItem.vlan.id,
          packagesIspId: item.fromIspPackageId,
          toPackageId: item.toIspPackageId,
          locationDescription: item.serviceAccount.location.locationDescription,
          customerOrganisationId: item.customerOrganisationId,
          // ispName: item.customerOrganisation.name,
          requestType: item.requestType,
          isChange: (item.requestType=='Termination')? true : false,
          ispNotification: true,
          fnoNotification: true,
          fnoContactName: null,
          ispContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
          fromSpeedProfileName: item.fromIspPackage.packagesFno.speedProfile.downloadMbps +'/'+item.fromIspPackage.packagesFno.speedProfile.uploadMbps,
          fromSpeedProfileId: item.fromIspPackage.packagesFno.speedProfileId,
          toSpeedProfileId: item.toIspPackage.packagesFno.speedProfileId,
          toSpeedProfileName: item.toIspPackage.packagesFno.speedProfile.downloadMbps +'/'+item.toIspPackage.packagesFno.speedProfile.uploadMbps,
          initialActivation: item.serviceAccount.initialActivation || null,
          fnoActivationDate: item.serviceAccount.fnoActivationDate || null,
          fnoDeactivationDate: item.serviceAccount.fnoDeactivationDate || null,
          ispActivationDate: item.serviceAccount.ispActivationDate || null,
          ispDeactivationDate: item.serviceAccount.ispDeactivationDate || null,
          requestedChangeDate: item.requestedDate,
          staticIpv4: item.serviceAccount.staticIpv4 || null,
          staticIpv6: item.serviceAccount.staticIpv6 || null,
          deviceId: item.serviceAccount.deviceId,
          isDeleted: false,
          isActive: true
        }).then(async response=>{
          await Api().put('/customer/endCustomerRequests/'+item.id,{
            isResolved: true,
            isAccepted: true,
            resolvedDate: new Date(),
            serviceAccountAuditLogId: response.data.id
          })
          this.initialize()
        })
    },
    async rejectCustomerRequest(item){
      confirm("Are you sure you would like to reject this request?")&&
      await Api().put('/customer/endCustomerRequests/'+item.id,{
            isResolved: true,
            isDenied: true,
            resolvedDate: new Date(),
          })
          this.initialize()
    },
    async getAllIspPackages() {
      Api()
        .get("/customer/packagesIsps/basic/active")
        .then(response => {
          this.allIspPackages = response.data;
        });
    },
    logServiceAccountChange() {
      if (this.changeRequestItem.fnoActivationDate !== null) {
        this.changeRequestItem.fnoActivationDate = new Date(
          this.changeRequestItem.fnoActivationDate
        )
          .toISOString()
          .substr(0, 10);
      }
      if (this.changeRequestItem.ispActivationDate !== null) {
        this.changeRequestItem.ispActivationDate = new Date(
          this.changeRequestItem.ispActivationDate
        )
          .toISOString()
          .substr(0, 10);
      }
      if (this.changeRequestItem.fnoDeactivationDate !== null) {
        this.changeRequestItem.fnoDeactivationDate = new Date(
          this.changeRequestItem.fnoDeactivationDate
        )
          .toISOString()
          .substr(0, 10);
      }
      if (this.changeRequestItem.ispDeactivationDate !== null) {
        this.changeRequestItem.ispDeactivationDate = new Date(
          this.changeRequestItem.ispDeactivationDate
        )
          .toISOString()
          .substr(0, 10);
      }
      if (this.changeRequestItem.initialActivation !== null) {
        this.changeRequestItem.initialActivation = new Date(
          this.changeRequestItem.initialActivation
        )
          .toISOString()
          .substr(0, 10);
      }
      if(this.changeRequestItem.requestType !== 'Termination'){
        this.changeRequestItem.isChange = true
      }
      Api().put("/serviceAccounts/" + this.changeRequestItem.id, {
        isChange: false
      });
      let toSpeedId = null
      let toSpeedName = null
      let toPackageId = null
      if(this.changeRequestItem.toSpeed){
        toSpeedId = this.changeRequestItem.toSpeed.packagesFno.speedProfileId
        toSpeedName = this.changeRequestItem.toSpeed.packagesFno.speedProfile.downloadMbps+'/'+this.changeRequestItem.toSpeed.packagesFno.speedProfile.uploadMbps
        toPackageId = this.changeRequestItem.toSpeed.id
      }
      Api()
        .post("/customer/serviceAccountsAuditLog", {
          status: "Pending",
          serviceAccountId: this.changeRequestItem.id,
          serviceAccountIdentifier: this.changeRequestItem.serviceAccountIdentifier,
          locationId: this.changeRequestItem.locationId,
          // vlanId: this.changeRequestItem.vlan.id,
          packagesIspId: this.changeRequestItem.packagesIspId,
          locationDescription: this.changeRequestItem.location.locationDescription,
          customerOrganisationId: this.changeRequestItem.packagesIsp.customerOrganisationId,
          ispName: this.changeRequestItem.customerOrganisation.name,
          requestType: this.changeRequestItem.requestType,
          isChange: this.changeRequestItem.isChange,
          ispNotification: true,
          fnoNotification: true,
          fnoContactName: null,
          ispContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
          fromSpeedProfileName: this.changeRequestItem.packagesIsp.packagesFno.speedProfile.downloadMbps +'/'+this.changeRequestItem.packagesIsp.packagesFno.speedProfile.uploadMbps,
          fromSpeedProfileId: this.changeRequestItem.packagesIsp.packagesFno.speedProfileId,
          toSpeedProfileId: toSpeedId,
          toSpeedProfileName: toSpeedName,
          toPackageId: toPackageId,
          initialActivation: this.changeRequestItem.initialActivation || null,
          fnoActivationDate: this.changeRequestItem.fnoActivationDate || null,
          fnoDeactivationDate: this.changeRequestItem.fnoDeactivationDate || null,
          ispActivationDate: this.changeRequestItem.ispActivationDate || null,
          ispDeactivationDate: this.changeRequestItem.ispDeactivationDate || null,
          requestedChangeDate: this.requestedChangeDate,
          staticIpv4: this.changeRequestItem.staticIpv4 || null,
          staticIpv6: this.changeRequestItem.staticIpv6 || null,
          deviceId: this.changeRequestItem.deviceId,
          isDeleted: this.changeRequestItem.isDeleted,
          isActive: this.changeRequestItem.isActive
        })
        .then(async response => {
          this.changeRequestItem.serviceAccountAuditLogId = response.data.id 
          // await this.acceptFNOChange(this.changeRequestItem)
            this.initialize(),
            this.changeRequestDialog=false
            this.changeRequestItem={}
        });
    },
    denyRequestChange(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      Api()
        .put("/serviceAccountsAuditLog/" + item.id, {
          fnoContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
          comment: this.denyReason,
          isActive: false,
          status: "Denied"
        })
        .then(this.initialize());
      }
    },
    acceptFNOChange(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      if (item.requestType !== "Termination") {
        let locationId = null;
        let deviceId = null;
        if (item.requestType !== "Migration") {
          locationId = item.location.id;
          deviceId = item.deviceId;
        } else {
          locationId = this.migrationLocationId;
          deviceId = null;
        }

        Api().put("/serviceAccounts/" + item.id, {
          ispDeactivationDate: this.requestedChangeDate,
          fnoDeactivationDate: this.requestedChangeDate
        });
        if (item.authenticationType === "PPPoE") {
          item.IPoEActive = null;
        } else {
          item.IPoEActive = true;
        }

        Api().post("/serviceAccounts", {
          serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
          authenticationType: item.authenticationType,
          pppoeUsername: item.pppoeUsername || null,
          pppoePassword: item.pppoePassword || null,
          IPoEMacAddress: item.IPoEMacAddress,
          initialActivation: item.initialActivation,
          fnoActivationDate: this.requestedChangeDate || null,
          fnoDeactivationDate: null,
          ispActivationDate: this.requestedChangeDate || null,
          ispDeactivationDate: null,
          staticIpv4: item.staticIpv4 || null,
          staticIpv6: item.staticIpv6 || null,
          isChange: true,
          locationId: locationId,
          deviceId: deviceId,
          packagesIspId:
            item.toSpeed.id || item.packagesIspId,
          vlanId: item.vlan.id,
          customerOrganisationId: item.customerOrganisationId,
          IPoEActive: false,
          isDeleted: false,
          isActive: true
        });
      } else {
        Api().put("/serviceaccounts/" + item.id, {
          fnoDeactivationDate: this.requestedChangeDate,
          ispDeactivationDate: this.requestedChangeDate
        });
      }
      Api()
        .put("/serviceAccountsAuditLog/" + item.serviceAccountAuditLogId, {
          fnoContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
          isActive: false,
          status: "Resolved",
          dateResolved: new Date()
        })
        .then(
          this.requestedChangeDate = new Date().toISOString().substr(0, 10),
          this.initialize()
        );
      }
    },

    fetchSpeedProfiles(){
      Api()
      .get('/speedProfiles')
      .then(response=>{
        console.log(response.data)
        this.allSpeedProfiles=response.data
      })
    },

    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    async changeRequest(item){
      if(this.authUpdate(this.$store.state.currentRoute)){
        this.changeRequestItem=item
        this.changeRequestItem.fromSpeed = item.packagesIsp.packagesFno.speedProfile
        console.log(item)
        console.log(this.allIspPackages)
       this.packagesIsp = await this.allIspPackages.filter(x=>x.isActive&&!x.isDeleted&&new Date()>= new Date(x.startDate)&&(x.endDate == null ||new Date()<=new Date(x.endDate))&&x.locationNetworkId === item.location.locationNetworkId)
       console.log(this.packagesIsp)
         this.changeRequestDialog=true
      }
    }
  }
}
</script>